<div *ngIf="purchasedItem; else noItem">
  <!-- Not Redeemed / expired-->
  @if (!purchasedItem?.RedeemDate && !expired()) {
    <div class="marketplace-wallet-item-list">
      <ng-container *ifScreenSize="screenType.Desktop">
        <ng-container *ngTemplateOutlet="carouselWallet; context: { $implicit: desktopOptions, width: 0 }"></ng-container>
      </ng-container>
      <ng-container *ifScreenSize="screenType.Mobile">
        @if (groupedItem?.count > 1) {
          <ng-container *ngTemplateOutlet="carouselWallet; context: { $implicit: mobileOptions, width: 305 }"></ng-container>
        } @else {
          <div class="single-wallet">
            <fgbcl-rewards-wallet-redeem-list-item
              [item]="purchasedItem"
              [multi]="false"
              [showButton]="false"
              orientation="landscape"
            ></fgbcl-rewards-wallet-redeem-list-item>
          </div>
        }
      </ng-container>
    </div>
    @if (options.showTransferButton) {
      <ng-container *ngIf="partners$ | async as partners">
        @if (partners?.length > 0) {
          <div class="wallet-transfer-button-wrapper">
            <button class="wallet-transfer-button" (click)="openTransferModal(transferItemModal)">
              <i class="material-symbols-outlined">azm</i> {{ 'fgbcl.rewards.wallet.transfer.button' | translate }}
            </button>
          </div>
        }
      </ng-container>
    }
  } @else {
    <!-- Redeemed view -->
    <fgbcl-rewards-wallet-redeem-list-item
      [item]="purchasedItem"
      [multi]="false"
      orientation="landscape"
    ></fgbcl-rewards-wallet-redeem-list-item>
  }
  @if (isDateAttribute) {
    <ng-container *fgbWebsiteContentFeatureFlag="'fgbcl.feature.flag.add.to.calendar'">
      <div
        [ngClass]="{
          'mt-3': groupedItem?.items?.length <= 1,
        }"
      >
        <fgbcl-add-to-calendar-modal></fgbcl-add-to-calendar-modal>
      </div>
    </ng-container>
  }

  <div class="loyalty-details w-100 mt-4">
    <h5 class="item-details-title">{{ 'marketplace.wallet.details.item.title' | translate }}</h5>
    <!-- Card Body -->
    <div class="wallet-details-container">
      <!-- Custom Field -->
      <ng-container *ngIf="purchasedItem.CustomFields && purchasedItem.CustomFields.length">
        <div
          class="wallet-details-item wallet-custom-fields"
          *ngFor="let customField of purchasedItem.CustomFields; let i = index"
        >
          <div class="wallet-details-item-label">{{ customField.DisplayName }}</div>
          <span class="wallet-details-item-value">{{ customField.DisplayValue }}</span>
        </div>
      </ng-container>

      <!-- Attribute -->
      <ng-container *ngIf="purchasedItem.Attributes?.length > 0">
        <div class="wallet-details-item wallet-attributes" *ngFor="let attribute of purchasedItem.Attributes; let i = index">
          <div class="wallet-details-item-label">{{ attribute.DisplayName }}</div>
          <div class="wallet-details-item-value">
            @switch (attribute.DisplayType) {
              @case (attributeDisplayType.Date) {
                <span
                  fgbclAttributeTransValue
                  [isWallet]="true"
                  [attributeList]="purchasedItem.Attributes"
                  [attributeDataOrId]="attribute.LogId"
                >
                </span>
              }
              @default {
                {{ attribute.DisplayValue }}
              }
            }
          </div>
        </div>
      </ng-container>

      <!-- Quantity -->
      @if (groupedItem?.count > 1 && !purchasedItem.RedeemDate && !expired()) {
        <div class="wallet-details-item wallet-quantity">
          <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.quantity' | translate }}</div>
          <div class="wallet-details-item-value">
            {{ groupedItem?.count }}
          </div>
        </div>

        <div class="wallet-details-item">
          @if (!groupPoints?.ecash && !groupPoints?.merchantValue) {
            <div class="wallet-details-item-label wallet-points-value">{{ 'fgbcl.rewards.wallet.points' | translate }}</div>
            <div *ngIf="groupPoints.points > 0" class="wallet-details-item-value wallet-points-value">
              {{ groupPoints?.points | FortressCurrencyPipe: 'PTS' }}
            </div>
            <!--Display text if value is 0-->
            <div *ngIf="groupPoints.points == 0" class="wallet-details-item-value wallet-points-value">
              {{ 'fgbcl.marketplace.item.free' | translate }}
            </div>
          } @else if (groupPoints?.ecash > 0) {
            <div class="wallet-details-item-label wallet-ecash-value">{{ 'marketplace.ecash.used' | translate }}</div>
            <div class="wallet-details-item-value wallet-ecash-value">
              {{ groupPoints?.ecash / 100 | FortressCurrencyPipe }}
            </div>
          } @else if (groupPoints?.merchantValue > 0) {
            <div class="wallet-details-item-label wallet-merchant-value">{{ 'marketplace.merchant.used' | translate }}</div>
            <div class="wallet-details-item-value wallet-merchant-value">
              {{ groupPoints?.merchantValue / 100 | FortressCurrencyPipe }}
            </div>
          }
        </div>
      } @else {
        <!-- Points -->
        <ng-container *ngIf="!purchasedItem.EcashValue && !purchasedItem.MerchantValue">
          <div class="wallet-details-item wallet-points-value">
            <div class="wallet-details-item-label">{{ 'fgbcl.rewards.wallet.points' | translate }}</div>
            <div class="wallet-details-item-value" *ngIf="purchasedItem.PointValue > 0">
              {{ purchasedItem.PointValue | FortressCurrencyPipe: 'PTS' }}
            </div>
            <!--Display text if value is 0-->
            <div *ngIf="purchasedItem.PointValue == 0" class="wallet-details-item-value wallet-points-value">
              {{ 'fgbcl.marketplace.item.free' | translate }}
            </div>
          </div>
        </ng-container>

        <!--Ecash-->
        <ng-container *ngIf="purchasedItem.EcashValue > 0">
          <div class="wallet-details-item wallet-ecash-value">
            <div class="wallet-details-item-label">{{ 'marketplace.ecash.used' | translate }}</div>
            <div class="wallet-details-item-value">
              {{ purchasedItem.EcashValue / 100 | FortressCurrencyPipe }}
            </div>
          </div>
        </ng-container>

        <!--Merchant-->
        <ng-container *ngIf="purchasedItem.MerchantValue > 0">
          <div class="wallet-details-item wallet-merchant-value">
            <div class="wallet-details-item-label">{{ 'marketplace.merchant.used' | translate }}</div>
            <div class="wallet-details-item-value">
              {{ purchasedItem.MerchantValue / 100 | FortressCurrencyPipe }}
            </div>
          </div>
        </ng-container>
      }
    </div>

    <div class="accordion accordion-flush" id="marketplace-wallet-accordion">
      <div class="accordion-item">
        <h2 class="accordion-header" id="accordion-desc-heading">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#accordion-desc"
            aria-expanded="true"
            aria-controls="accordion-desc"
          >
            {{ 'fgbcl.rewards.wallet.description' | translate }}
          </button>
        </h2>
        <div id="accordion-desc" class="accordion-collapse collapse show" aria-labelledby="accordion-desc-heading">
          <div class="accordion-body">
            <fgbcl-short-long-description [description]="purchasedItem.Description"> </fgbcl-short-long-description>
          </div>
        </div>
      </div>

      <!--Terms-->
      <ng-container *ngIf="purchasedItem.TermsAndConditions">
        <div class="accordion-item">
          <h2 class="accordion-header" id="accordion-terms-heading">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#accordion-terms"
              aria-expanded="false"
              aria-controls="accordion-terms"
            >
              {{ 'fgbcl.rewards.wallet.terms' | translate }}
            </button>
          </h2>
          <div id="accordion-terms" class="accordion-collapse collapse" aria-labelledby="accordion-terms-heading">
            <div class="accordion-body">
              <fgbcl-short-long-description [description]="purchasedItem.TermsAndConditions"> </fgbcl-short-long-description>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #noItem>
  <div class="text-center m-5">
    <i>{{ 'wallet.no.items.found' | translate }}</i>
  </div>
</ng-template>

<ng-template #carouselWallet let-options let-width="width">
  <owl-carousel-o [options]="options">
    <ng-container *ngFor="let data of groupedItem?.items">
      <ng-template carouselSlide [width]="width">
        <fgbcl-rewards-wallet-redeem-list-item
          [item]="data"
          [multi]="false"
          [showButton]="false"
          orientation="landscape"
        ></fgbcl-rewards-wallet-redeem-list-item>
      </ng-template>
    </ng-container>
  </owl-carousel-o>
</ng-template>

<!-- Transfer Modal -->
<ng-template #transferItemModal let-modal>
  <div class="wallet-transfer-item-modal-content">
    <div class="wallet-transfer-item-modal-header">
      <h6 class="mb-0">{{ 'fgbcl.marketplace.wallet.transfer.modal.title' | translate }}</h6>
    </div>
    <hr class="m-0" />
    <div class="wallet-transfer-item-modal-body">
      <p>{{ 'fgbcl.wallet.transfer.instructions' | translate }}</p>
      <div class="select-partner-form">
        <div class="form-floating">
          <select
            class="form-select"
            id="floatingSelect"
            aria-label="Floating label select example"
            [(ngModel)]="selectedPartner"
            (change)="onPartnerSelect($event)"
          >
            <option selected hidden></option>
            @for (partner of partners$ | async; track partner.MemberId) {
              <option [ngValue]="partner">{{ partner.FullName }} ({{ partner.Email }})</option>
            }
          </select>
          <label for="floatingSelect">{{ 'fgbcl.wallet.transfer.select.partner' | translate }}</label>
        </div>
        <div class="wallet-transfer-input">
          <ng-container *ngTemplateOutlet="inputTemplate"></ng-container>
        </div>
      </div>
      @if (hasError) {
        <div class="error-message">
          {{ 'fgbcl.marketplace.wallet.transfer.item.error.' + errorCode | translate }}
        </div>
      }
    </div>
    <hr class="m-0" />
    <div class="wallet-transfer-item-modal-footer">
      <button class="btn text-danger me-2 fw-bold" (click)="modal.close()">
        {{ 'fgbcl.wallet.transfer.button.cancel' | translate }}
      </button>
      <button class="btn btn-success fw-bold" (click)="transferItem()" [disabled]="!selectedPartner">
        {{ 'fgbcl.wallet.transfer.button.ok' | translate }}
      </button>
    </div>
  </div>
</ng-template>
<!-- End Transfer Modal -->

<ng-template #inputTemplate>
  <div class="number-input-wrapper">
    <button class="input-increase-btn" [disabled]="inputNumber <= 1">
      <i class="material-symbols-outlined" (click)="decrease()">remove</i>
    </button>
    <input type="text" [(ngModel)]="inputNumber" (input)="onTransferItemInput($event)" />

    <button class="input-decrease-btn" [disabled]="inputNumber >= inputMax">
      <i class="material-symbols-outlined" (click)="increase()">add</i>
    </button>
  </div>
</ng-template>
